module.exports = __webpack_public_path__ + "files/fedbae4f00c5c8a96fb95bea32493122.png";